module.exports = __webpack_public_path__ + "public/img/明星产品_CN.2ed17932.png";